export const GET_STORY_SHARES = 'GET_STORY_SHARES';
export const ADD_STORY_SHARE = 'ADD_STORY_SHARE';
export const UPDATE_STORY_SHARE = 'UPDATE_STORY_SHARE';
export const REMOVE_STORY_SHARE = 'REMOVE_STORY_SHARE';
export const MAKE_PUBLIC_STORY_SHARE = 'MAKE_PUBLIC_STORY_SHARE';
export const COMMIT_STAGED_STORY_SHARES = 'COMMIT_STAGED_STORY_SHARES';
export const RECEIVE_STORY_SHARE_DELETION = 'RECEIVE_STORY_SHARE_DELETION';
export const ARCHIVE_STORY = 'ARCHIVE_STORY';
export const UNARCHIVE_STORY = 'UNARCHIVE_STORY';
